import VisHiddenText from './VisHiddenText';

export default VisHiddenText;
